<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" lg="6" sm="12">
        <v-card>
          <v-list-item>
            <v-list-item-avatar>
                <v-icon>mdi-hexagon-multiple</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="headline">工事情報編集</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-card-text>
            <v-form ref="construction_form" v-model="valid" @submit.prevent>
              <v-select label="部署" :items="departmentItems" item-text="name" item-value="value" v-model="department" :rules="departmentRules" no-data-text="データがありません" dense outlined return-object>
                  <template v-slot:append>
                      <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                  </template>
              </v-select>
              <v-text-field label="工事名" v-model="construction_name" :rules="constructionNameRules" dense outlined required>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-text-field label="工事場所" v-model="place" :rules="placeRules" dense outlined>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-text-field>
              <v-menu min-width="290px" max-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-on="on" label="工期(自)" v-model="startFormatted" :rules="constructionDateRules" dense outlined readonly @blur="start_date = parseDate(startFormatted)">
                    <template v-slot:append>
                      <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="start_date" no-title scrollable actions locale="ja-jp" :close-on-content-click="true" :day-format="date => new Date(date).getDate()"/>
              </v-menu>
              <v-menu min-width="290px" max-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-on="on" label="工期(至)" v-model="endFormatted" :rules="constructionDateRules" dense outlined readonly @blur="end_date = parseDate(endFormatted)">
                    <template v-slot:append>
                      <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                    </template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="end_date" no-title scrollable actions locale="ja-jp" :close-on-content-click="true" :day-format="date => new Date(date).getDate()"/>
              </v-menu>
              <v-text-field label="発注者" v-model="order_name" :rules="orderNameRules" dense outlined></v-text-field>
              <v-text-field label="施工者" v-model="builder_name" :rules="builderNameRules" dense outlined></v-text-field>
              <v-text-field v-if="isReceived" v-model="acceptPrice" prefix="¥" label="請負金額" :rules="acceptPriceRules" dense outlined required/>
              <v-select label="監督者" v-model="management_user" :rules="managementUserNameRules" :items="management_user_list" item-text="name" item-value="value" no-data-text="データがありません" dense outlined return-object>
                <template v-slot:append>
                  <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                </template>
              </v-select>
              <v-checkbox v-model="percentage_flg" :label="percentage_label"></v-checkbox>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-1" class="mr-3" :to="{ name: 'ConstructionMasterDetail', params: { id: this.editId } }" depressed>キャンセル</v-btn>
            <v-btn color="primary" @click.prevent="checkDialog" :disabled="!valid" depressed>確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleUpdate
        @updated="dialogEdit" @canceled="dialogCancel"/>
    </v-row>
  </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import statusList from "@/helpers/const";
  import ConstructionApi from "@/api/construction-api"
  import CustomDialog from "@/components/custom_ui/CustomDialog"
  import Rule from "@/validation/rules"

  export default {
    components: {
      CustomDialog
    },
    props: ["user"],
    data: () => ({
      // 共通コンポーネント: ダイアログ関連
      loading: false,
      dialogMaxWith: 500,
      dialogTitle: '',
      dialogItems: [],
      dialogDrawer: false,

      // フォームの項目
      department: null,
      departmentItems: [],
      construction_name: '',
      construction_number: '-',
      place: '',
      start_date: '',
      end_date: '',
      order_name: '',
      builder_name: '',
      acceptPrice: 0,
      percentage_flg: true,
      percentage_label: '歩掛あり',
      management_user: null,
      management_user_list: [],

      startFormatted: "",
      endFormatted: "",
      editId: null,

      statuses: {
        notReceived: { name: "未受注", value: 0 },
        received: { name: "受注済", value: 1 },
        missing: { name: "失注済", value: 2 },
        reflect: { name: "実績反映済", value: 3 }
      },
      isNotReceived: false,
      isReceived: false,
      isCompleted: false,

      // バリデーション関連
      valid: true,
      departmentRules: Rule.departmentRules,
      constructionNameRules: Rule.constructionNameRules,
      placeRules: Rule.placeRules,
      constructionDateRules: Rule.constructionDateRules,
      orderNameRules: Rule.orderNameRules,
      builderNameRules: Rule.builderNameRules,
      managementUserNameRules:Rule.managementUserNameRules,
      acceptPriceRules: Rule.acceptPriceRules
    }),
    created () {
      this.initialize()
    },
    watch: {
      percentage_flg (val) { this.percentage_label = val ? '歩掛あり' : '歩掛なし'; },
      'start_date': function(){
        if (this.end_date < this.start_date) {
            this.end_date = this.start_date;
        }
        this.startFormatted = this.formatDate(this.start_date);
      },
      'end_date': function(){
        if (this.start_date > this.end_date) {
            this.start_date = this.end_date;
        }
        this.endFormatted = this.formatDate(this.end_date);
      },
    },
    methods: {
      isLoading() {
        this.loading = !this.loading;
        this.$emit("loading", this.loading);
      },
      initialize () {
        this.isLoading();
        this.constructionApi = new ConstructionApi()
        this.editId = this.$route.params.id;
        const promise = this.constructionApi.info(this.editId);
        promise.then((response) => {
          if (this.statuses.notReceived.value === response.data.body.construction_info.status) {
            this.isNotReceived = true;
          }
          if (this.statuses.received.value === response.data.body.construction_info.status) {
            this.isReceived = true;
          }
          if (this.statuses.reflect.value === response.data.body.construction_info.status ||
              this.statuses.missing.value === response.data.body.construction_info.status) {
            this.isCompleted = true;
          }

          for (var department of response.data.body.department_list) {
            var department_name = department.name;
            if (department.section) {
                department_name = department.name + " - " + department.section;
            }
            this.departmentItems.push({
                name: department_name,
                value: department.id
            });
          }
          for (var user of response.data.body.user_list) {
            this.management_user_list.push({
              name: user.user_name, value: user.id
            });
          }
          this.management_user = this.management_user_list.find((user) => user.value === response.data.body.construction_info.management_user);
          this.department = this.departmentItems.find(item => { return item.value === response.data.body.construction_info.department_id });
          this.construction_number = response.data.body.construction_info.construction_number;
          this.construction_name = response.data.body.construction_info.construction_name;
          this.place = response.data.body.construction_info.place;
          this.start_date = this.parseDate(response.data.body.construction_info.start_date);
          this.startFormatted = response.data.body.construction_info.start_date;
          this.end_date = this.parseDate(response.data.body.construction_info.end_date);
          this.endFormatted = response.data.body.construction_info.end_date;
          if (response.data.body.construction_info.order_name) {
            this.order_name = response.data.body.construction_info.order_name;
          }
          if (response.data.body.construction_info.builder_name) {
            this.builder_name = response.data.body.construction_info.builder_name;
          }
          this.acceptPrice = response.data.body.construction_info.estimated_price;
          this.percentage_flg = response.data.body.construction_info.percentage_flg;
          this.$refs.construction_form.resetValidation();
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.$emit('logoutConform');
            } else if (error.response.data.status == statusList.status.entityError) {
              this.$emit("error",error.response.data.message);
              this.$router.push({ name: "ConstructionMaster" })
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
            this.isLoading();
        });
      },
      // 日付フォーマット
      formatDate (date) {
        if (!date) return null;
        const [year, month, day] = date.split('-');
        return `${year}/${month}/${day}`;
      },
      parseDate (date) {
        if (!date) return null;
        const [year,month, day] = date.split('/');
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      },
      // 編集ボタン押下時イベント
      checkDialog () {
        this.dialogTitle = '編集しますか？'
        this.dialogItems = [
          { name: '部署', value: this.department.name },
          { name: '工事名', value: this.construction_name },
          { name: '工事場所', value: this.place },
          { name: '工期(自)', value: this.start_date },
          { name: '工期(至)', value: this.end_date},
          { name: "発注者", value: this.order_name },
          { name: "施工者", value: this.builder_name },
          { name: "請負金額", value: this.acceptPrice },
          { name: "監督者", value: this.management_user.name },
          { name: "歩掛", value: this.percentage_flg ? 'あり' : 'なし' }
        ]
        this.dialogDrawer = true
      },
      dialogCancel() {
        this.dialogDrawer = false
      },
      dialogEdit() {
        this.isLoading();
        const params = {
          department_id: String(this.department.value),
          construction_number: this.construction_number,
          name: this.construction_name,
          place: this.place,
          start_date: this.start_date,
          end_date: this.end_date,
          order_name: this.order_name,
          builder_name: this.builder_name,
          estimated_price: this.acceptPrice,
          management_user: this.management_user.value,
          percentage_flg: this.percentage_flg ? '1' : '0'
        }
        const promise = this.constructionApi.update(this.editId, params)
        promise.then((response) => {
            this.$router.push({ name: "ConstructionMasterDetail", params: { id: this.editId } })
            this.$emit('success', response.data.message)
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if (error.response) {
            if (error.response.data.status == statusList.status.authError) {
              this.dialogDrawer = false;
              this.$emit('logoutConform');
            } else {
              this.$emit("error",error.response.data.message);
            }
          } else {
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      }
    },
  }
</script>
